import type { TermDetailModalProps } from '@/interfaces/component/term.interface';
import BaseModal from '@/components/modal/BaseModal';

const TermDetailModal = ({ showModal, handleShowModal, modalTitle, termDetailUrl }: TermDetailModalProps) => {
  return (
    <BaseModal modalTitle={modalTitle} showModal={showModal} handleShowModal={handleShowModal} closeButtonTitle="확인" isFullHeight={true}>
      <iframe src={termDetailUrl} width="100%" height="100%" allowFullScreen style={{ border: 'none' }}>
        <p>
          <a href="/ko/docs/Glossary" target="_blank">
            iframes을 지원하지 않는 브라우저용 링크
          </a>
        </p>
      </iframe>
    </BaseModal>
  );
};

export default TermDetailModal;
